$(document).ready(function () {

	if ($('[data-component="header"]').length > 0) {
		new Header();
	}
	if ($('[data-component="warning-bar"]').length > 0) {
		new WarningBar();
	}
	if ($('[data-component="banner-slider"]').length > 0) {
		new BannerSlider();
	}
	if ($('[data-component="banner"]').length > 0) {
		new Banner();
	}
	if ($('[data-component="card-text-list"]').length > 0) {
		new CardTextList();
	}
	if ($('[data-component="quick-access"]').length > 0) {
		new	QuickAccess();
	}
	if ($('[data-component="news-list"]').length > 0) {
		new NewsList();
	}
	if ($('[data-component="programs-and-projects"]').length > 0) {
		new ProgramsAndProjects();
	}
	if ($('[data-component="search-results"]').length > 0) {
		new SearchResults();
	}
	if ($('[data-component="water-stages"]').length > 0) {
		new WaterStages();
	}
	if ($('[data-component="synced-slider"]').length > 0) {
		new SyncedSlider();
	}
	if ($('[data-component="project-modal"]').length > 0) {
		new ProjectModal();
	}
	if ($('[data-component="card-img-list"]').length > 0) {
		new CardImgList();
	}
	if ($('[data-component="table-list"]').length > 0) {
		new TableList();
	}
	if ($('[data-component="accordion"]').length > 0) {
		new Accordion();
	}
	if ($('[data-component="contact-form"]').length > 0) {
		new ContactForm();
	}
	if ($('[data-component="card-img-text"]').length > 0) {
		new CardSlider();
	}
	if ($('[data-component="card-institucional-list"]').length > 0) {
		new CardInstitutionalList();
	}

});
